<template>
  <div>

    <!-- Catalogos eManifiestoMV-->
    <v-menu v-if="view_emanifiesto == 1 && menu_catalogos" bottom nav offset-y origin="center center" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn text v-on="on" :title="fullWidth < 1024 ? 'Catálogos' : ''" :icon="fullWidth <= 1024">
          <v-icon>list</v-icon>
          <span class="caption">Catálogos</span>
        </v-btn>
      </template>
      <v-list :tile="false" nav>
        <app-bar-item v-if="valida_permiso('MVs.catalogos.emisores.destinatarios')" to="/catalogos/emisores_destinatarios"
          @click.shift="openNew('/catalogos/emisores_destinatarios');">
          <v-icon>mdi-circle-small</v-icon>Emisor - Proveedor
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.catalogos.agentes')" to="/catalogos/agentes" @click.shift="openNew('/catalogos/agentes');">
          <v-icon>mdi-circle-small</v-icon>Agentes Aduanales
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.catalogos.representantes')" to="/catalogos/representantes" @click.shift="openNew('/catalogos/representantes');">
          <v-icon>mdi-circle-small</v-icon>Representantes Legales
        </app-bar-item>

      </v-list>
    </v-menu>
    <!-- Utilerias eManifiestoMV-->
    <v-menu v-if="view_emanifiesto == 1 && menu_utilerias" bottom nav offset-y origin="center center" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn text v-on="on" :title="fullWidth < 1024 ? 'Catálogos' : ''" :icon="fullWidth <= 1024">
          <v-icon>dashboard</v-icon>
          <span class="caption">Utilerías</span>
        </v-btn>
      </template>
      <v-list :tile="false" nav>
        <app-bar-item v-if="valida_permiso('MVs.catalogos.usuarios')" to="/catalogos/usuariosmv" @click.shift="openNew('/catalogos/usuariosmv');">
          <v-icon>mdi-circle-small</v-icon>Usuarios
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.catalogos.acceso.usuarios')" to="/catalogos/acceso_usuarios" @click.shift="openNew('/catalogos/acceso_usuarios');">
          <v-icon>mdi-circle-small</v-icon>Log de Accesos
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.apendices')" to="/apendices/41" @click.shift="openNew('/apendices/41');">
          <v-icon>mdi-circle-small</v-icon>Apéndices
        </app-bar-item>

        <app-bar-item v-if="valida_permiso('MVs.catalogos.enotes')" to="/catalogos/enotes" @click.shift="openNew('/catalogos/enotes');">
          <v-icon>mdi-circle-small</v-icon>eNotes
        </app-bar-item>
      </v-list>
    </v-menu>


    <!-- Vucem-Transmision Manifiesto -->
    <v-menu v-if="view_emanifiesto == 1 && menu_transmision" nav bottom offset-y origin="center center" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn :icon="fullWidth <= 1024" :title="fullWidth < 1024 ? 'Vucem-Transmision' : ''" v-on="on" v-tippy text>
          <v-icon>launch</v-icon>
          <span class="caption">Vucem-Transmisión</span>
        </v-btn>
      </template>
      <v-list :tile="false" nav>
        <app-bar-item v-if="valida_permiso('MVs.recuperaciones.coves')" to="/recuperaciones_coves" @click.shift="openNew('/recuperaciones_coves');">

          <v-icon>mdi-circle-small</v-icon>Solicitud de Consulta COVES

        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.recuperaciones.edocs')" to="/recuperaciones_edocs" @click.shift="openNew('/recuperaciones_edocs');">

          <v-icon>mdi-circle-small</v-icon>Solicitud de Consulta EDOCUMENTS

        </app-bar-item>
              <v-divider />
        <app-bar-item @click.native="downloadFile('COVE_DiccionarioDeDatos.pdf');">

          <v-icon>mdi-circle-small</v-icon>Diccionario de COVE

        </app-bar-item>

      </v-list>
    </v-menu>
    <!-- eManifest -->
    <v-menu v-if="view_emanifiesto == 1 && menu_emanifiesto" nav bottom offset-y origin="center center" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn :icon="fullWidth <= 1024" :title="fullWidth < 1024 ? 'eManifiesto' : ''" v-on="on" v-tippy text>
          <v-icon>mdi-clipboard-list-outline</v-icon>
          <span class="caption">eManifiesto</span>
        </v-btn>
      </template>
      <v-list :tile="false" nav>
          <app-bar-item v-if="valida_permiso('EmanifiestoMV.bitacora')" to="/manifestacion/transmitir" @click.shift="openNew('/manifestacion/transmitir');">
          <v-icon>mdi-circle-small</v-icon>Solicitud y Bitácora de Gestión MVe
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.mv.bitacora')"  to="/mv_bitacora" @click.shift="openNew('/mv_bitacora');">
              <v-icon>mdi-circle-small</v-icon> Solicitud MVe - Archivo M
            </app-bar-item>

            <app-bar-item v-if="valida_permiso('MVs.mv.bitacora.cancelar')" to="/manifestacion/canceladas" @click.shift="openNew('/manifestacion/canceladas');">
              <v-icon>mdi-circle-small</v-icon> MVe - Canceladas
            </app-bar-item>
        <v-divider />
        <app-bar-item>
          <span style="font-weight: bold;">Información Complementaria</span>
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.mv.layouts')" to="/mv_layouts" @click.shift="openNew('/mv_layouts');">
          <v-icon>mdi-circle-small</v-icon>  Layout - Complementos MVe <v-spacer/> <v-icon title="Descargar"> mdi-folder-zip-outline</v-icon>
        </app-bar-item>

        <app-bar-item v-if="valida_permiso('MVs.mv.cargava')" to="/mv_cargava" @click.shift="openNew('/mv_cargava');">
          <v-icon>mdi-circle-small</v-icon>  Información de Pago <v-spacer/> <v-icon>mdi-upload</v-icon>
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.mv.cargainc')" to="/mv_cargainc" @click.shift="openNew('/mv_cargainc');">
          <v-icon>mdi-circle-small</v-icon> Incrementables <v-spacer/> <v-icon>mdi-upload</v-icon>
        </app-bar-item>
        <app-bar-item  v-if="valida_permiso('MVs.mv.cargadec')" to="/mv_cargadec" @click.shift="openNew('/mv_cargadec');">
          <v-icon>mdi-circle-small</v-icon> Decrementables <v-spacer/> <v-icon>mdi-upload</v-icon>
        </app-bar-item>
        <app-bar-item  v-if="menu_layouts" to="/mv_bitacora_ly" @click.shift="openNew('/mv_bitacora_ly');">
          <v-icon>mdi-circle-small</v-icon> Bitácora de Carga <v-spacer/>
        </app-bar-item>


       <!--  <v-divider />
        <app-bar-item disabled>
          <v-icon>mdi-circle-small</v-icon> Diccionario de MV
        </app-bar-item> -->
      </v-list>
    </v-menu>

    <!-- Edrive Manifiesto -->
    <v-menu v-if="view_emanifiesto == 1 && menu_edrive" bottom offset-y origin="center center" nav transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024 ? 'eDrive' : ''" v-tippy>
          <v-icon>account_tree</v-icon>
          <span class="caption" v-show="fullWidth > 1024">E-Drive</span>
        </v-btn>
      </template>
      <v-list :tile="false" nav>
        <app-bar-item v-if="valida_permiso('MVs.mv.edrive')" to="/mv_edrive" @click.shift="openNew('/mv_edrive');">

          <v-icon>mdi-circle-small</v-icon>Consultar Expediente

        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.manifestacion.expediente')" to="/manifestacion/expediente" @click.shift="openNew('/manifestacion/expediente');">

          <v-icon>mdi-circle-small</v-icon>Descargar Expediente

        </app-bar-item>
        <v-divider />
        <app-bar-item>
          <span style="font-weight: bold;">ADJUNTOS A EXPEDIENTE</span>
        </app-bar-item>

        <app-bar-item v-if="valida_permiso('MVs.mv.adjuntar.expediente')" to="#" disabled>
          <v-icon>mdi-circle-small</v-icon> Adjuntar Documentos
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.mv.expediente.proceso')" to="#" disabled>
          <v-icon>mdi-circle-small</v-icon> Expediente en Proceso
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.mv.chk.list.adjuntos')" to="/consulta_adjuntos_mv"  @click.shift="openNew('/consulta_adjuntos_mv');" disabled>
          <v-icon>mdi-circle-small</v-icon> CheckList Archivos Adjuntos
        </app-bar-item>

      </v-list>
    </v-menu>

    <!-- Reportes Manifiesto -->
    <v-menu bottom offset-y origin="center center" nav transition="scale-transition" v-if="view_emanifiesto == 1 && menu_reportes">
      <template v-slot:activator="{ attrs, on }">
        <v-btn text v-on="on" :icon="fullWidth <= 1024" :title="fullWidth < 1024 ? 'Reportes' : ''" v-tippy>
          <v-icon>file_copy</v-icon>
          <span class="caption" v-show="fullWidth > 1024">Reportes</span>
        </v-btn>
      </template>
      <v-list :tile="false" nav>

        <app-bar-item v-if="valida_permiso('MVs.mv.procesos')" disabled>
          <v-icon>mdi-circle-small</v-icon> Procesos creados y estatus MVe
        </app-bar-item>

        <app-bar-item v-if="valida_permiso('MVs.mv.pedimentos')" disabled>
          <v-icon>mdi-circle-small</v-icon> Pedimentos asociados a MVe
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.mv.consultar.coves')" to="/mv_consultar_coves" @click.shift="openNew('/mv_consultar_coves');">
          <v-icon>mdi-circle-small</v-icon>Reporte Coves
        </app-bar-item>
        <app-bar-item v-if="valida_permiso('MVs.mv.consultar.edocs')" to="/mv_consultar_edocs" @click.shift="openNew('/mv_consultar_edocs');">
          <v-icon>mdi-circle-small</v-icon>Reporte Edocuments
        </app-bar-item>

        <app-bar-item v-if="valida_permiso('MVs.manifestacion.directo.archivom')" to="/manifestacion/directo_archivom" @click.shift="openNew('/manifestacion/directo_archivom');">
          <v-icon>mdi-circle-small</v-icon>Reporte Directo Archivo M
        </app-bar-item>
        <v-divider v-if="is_cliente" />

        <app-bar-item @click.native="downloadFile('emanifiesto.pdf');">
          <v-icon>mdi-circle-small</v-icon>Manual de Usuario
        </app-bar-item>

      </v-list>
    </v-menu>

  </div>
</template>

<script>
// Components
import {
  VHover,
  VListItem
} from "vuetify/lib";

// Utilities
import {
  mapState,
  mapMutations
} from "vuex";

import Util from "@/util";
import axios from "axios";

export default {
  name: "emanifiestoDA",

  created() {
    this.$local_storage.set("es_emanifiesto_mv", this.$local_storage.get("emanifiestoMV.bitacora") == 100);
  },
  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({
              hover
            }) => {
              return h(
                VListItem, {
                attrs: this.$attrs,
                class: {
                  "black--text": !hover,
                  "white--text secondary elevation-12": hover
                },
                props: {
                  activeClass: "",
                  dark: hover,
                  link: true,
                  ...this.$attrs
                }
              },
                this.$slots.default
              );
            }
          }
        });
      }
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    fab: false,

    show_loading: false,
    notificationsNumber: 0,
    show: true,
    rfc: "",
    razon: "",
    tipo_usuario: "",
    id_cliente: 0,
    minifiedLeft: false,
    hiddenLeft: false,
    avatar: "undefined",
    fullWidth: document.documentElement.clientWidth,
    notifications: [
      "Mike John Responded to your email",
      "You have 5 new tasks",
      `You're now friends with Andrew`,
      "Another Notification",
      "Another one"
    ]
  }),

  computed: {
    ...mapState(["drawer"]),

    view_emanifiesto() {
      if(this.$local_storage.get("rfc_agencia") != '')
        return 1;
      else
        return 0;
    },
    view_trafico() {
      return this.$store.state.trafico;
    },
    view_costing() {
      return this.$store.state.costing;
    },
    view_carta_porte() {
      return this.$store.state.carta_porte;
    },

    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },

    Admin() {
      return (
        this.$local_storage.get("tipo_usuario") == "Super Usuario" &&
        this.$local_storage.get("id_cliente") == 0
      );
    },
     menu_datos() {
      return (
        this.$local_storage.get("id_cliente") > 0 &&
        (
          this.valida_permiso("MVs.clientes.domicilio") ||
          this.valida_permiso("MVs.clientes.certificados")
        )
      );
    },
     menu_catalogos() {
      return (
        this.$local_storage.get("id_cliente") > 0 &&
        (
          this.valida_permiso("MVs.catalogos.emisores.destinatarios") ||
          this.valida_permiso("MVs.catalogos.agentes") ||
          this.valida_permiso("MVs.catalogos.representantes")
        ) || this.view_emanifiesto == 1
      );
    },
     menu_utilerias() {
      return (
        this.$local_storage.get("id_cliente") > 0 &&
        (
          this.valida_permiso("MVs.catalogos.usuarios") ||
          this.valida_permiso("MVs.catalogos.acceso.usuarios") ||
          this.valida_permiso("MVs.apendices") ||
          this.valida_permiso("MVs.utilerias.reglas.expediente.manifestacion") ||
          this.valida_permiso("MVs.mv.chklist") ||
          this.valida_permiso("MVs.catalogos.enotes")
        ) || this.view_emanifiesto == 1
      );
    },

    menu_transmision() {
      return (
        this.$local_storage.get("id_cliente") > 0 &&
        (
          this.valida_permiso("MVs.recuperaciones.coves") ||
          this.valida_permiso("MVs.recuperaciones.edocs") ||
          this.valida_permiso("MVs.transmision.cove") ||
          this.valida_permiso("MVs.transmision.covedetalles") ||
          this.valida_permiso("MVs.transmision.edocument") ||
          this.valida_permiso("MVs.reportes.transmitted.coves") ||
          this.valida_permiso("MVs.reportes.transmitted.edocs")
        ) || this.view_emanifiesto == 1
      );
    },


    menu_emanifiesto() {
      return (
        this.$local_storage.get("id_cliente") > 0 &&
        (
          this.valida_permiso("EmanifiestoMV.bitacora") ||
          this.valida_permiso("MVs.mv.bitacora") ||
          this.valida_permiso("MVs.mv.bitacora.cancelar") ||
          this.valida_permiso("MVs.mv.bitacora.transmitir") ||
          this.valida_permiso("MVs.mv.layouts") ||
          this.valida_permiso("MVs.mv.cargava") ||
          this.valida_permiso("MVs.mv.cargainc") ||
          this.valida_permiso("MVs.mv.cargadec")
        ) || this.view_emanifiesto == 1
      );
    },
     menu_layouts() {
      return (
        this.$local_storage.get("id_cliente") > 0 &&
        (
          this.valida_permiso("MVs.mv.cargava") ||
          this.valida_permiso("MVs.mv.cargainc") ||
          this.valida_permiso("MVs.mv.cargadec")
        ) || this.view_emanifiesto == 1
      );
    },
    menu_edrive() {
      return (
        this.$local_storage.get("id_cliente") > 0 &&
        (
          this.valida_permiso("MVs.mv.edrive") ||
          this.valida_permiso("MVs.manifestacion.expediente") ||
          this.valida_permiso("MVs.mv.adjuntar.expediente") ||
          this.valida_permiso("MVs.mv.expediente.proceso") ||
          this.valida_permiso("MVs.mv.chk.list.adjuntos")
        ) || this.view_emanifiesto == 1
      );
    },
    menu_reportes() {
      return (
        this.$local_storage.get("id_cliente") > 0 &&
        (
          this.valida_permiso("MVs.mv.procesos") ||
          this.valida_permiso("MVs.mv.pedimentos") ||
          this.valida_permiso("MVs.mv.consultar.coves") ||
          this.valida_permiso("MVs.mv.consultar.edocs") ||
          this.valida_permiso("MVs.manifestacion.directo.archivom")
        )
      );
    },

    is_cliente() {
      return (
        this.$local_storage.get("id_cliente") > 0
      );
    },

    esGrupo() {
      return this.$local_storage.get("panel_grupo") == 1 && this.$local_storage.get('grupo') > 0 && this.$local_storage.get("tipo_usuario") == "Grupo" && this.$local_storage.get("id_cliente") == 0;
    },

  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER"
    }),
    valida_permiso(permiso) {
      return (
        this.$local_storage.get(permiso) == 100 && this.$local_storage.get("id_cliente") > 0 || this.$local_storage.get("tipo_usuario") == "Super Usuario"
      );
    },
    valida_permiso_t(permiso) {
      return (
        this.$local_storage.get(permiso) == 100 || (this.$local_storage.get("id_perfil") == 0 && this.$local_storage.get("perfil_grupo") == 0)
      );
    },

    handleFullScreen() {
      Util.toggleFullScreen();
    },

    change() {
      this.$router.push("/usuarios/change").catch(() => { });
    },
    openNew: function (h) {
      window.open(h, "_blank");
    },
    base64ToArrayBuffer: function (base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    downloadFile: function (key) {
      this.$root.$dialogLoader.show('Espere un momento por favor..');
      var datos = {
        id: key,
        bucket: "descargas.econnectpro.mx"
      }
      let nombre_download = key.split("/").pop();
      axios.post(this.$hostname + "s3/download/", datos, {
        "Content-type": "application/json",
        "Access-Control-Allow-Origin": "*",
        Allow: "POST",
        "cache-control": "no-cache",
      })
        .then(response => {
          var bytes = this.base64ToArrayBuffer(response.data);
          let blob = new Blob([bytes], {
            type: response.headers["content-type"]
          }),
            url = window.URL.createObjectURL(blob);

          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = nombre_download;
          a.click();
          a.parentNode.removeChild(a);
        })
        .catch(error => {
          console.log(error);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });

    },

  },

};
</script>

<style scoped>
.v-menu__content .v-list--nav .v-list-item {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 5px;
  text-decoration: none;
}

.v-sheet button.v-btn.v-size--default:not(.v-btn--icon):not(.v-btn--fab) {
  padding-left: 10px !important;
}
</style>
